module.exports = __webpack_public_path__ + "img/236.36defe85.jpg";